module.exports = __webpack_public_path__ + "static/img/img1.d28ea98.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/ypjg/images/img1.png
// module id = KHPt
// module chunks = 1